const API_CONFIG = {
  storageAccount: "mfprojects",
  tableName: "website",
  sasToken:
    "sv=2024-11-04&ss=t&srt=sco&sp=rwdlacu&se=2035-07-04T17:08:25Z&st=2025-07-04T09:08:25Z&spr=https&sig=X7s%2BFIyYcKvRzSxRNAp5BUJEe2YUcg8nojkn9fIfcTY%3D",
};

const getBaseUrl = () =>
  `https://${API_CONFIG.storageAccount}.table.core.windows.net/${API_CONFIG.tableName}`;

const safeParseArray = (raw) => {
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const emptySettings = () => ({
  about: "",
  contact: { adresse: "", email: "", telefon: "", instagram: "" },
  impressum: "",
  danke: [],
  elGatoMuerto: [],
  elGatoMuertoImages: [],
  elGatoMuertoTextOben: "",
  elGatoMuertoTextUnten: "",
});

export const getWebsiteSettings = async () => {
  try {
    const url = `${getBaseUrl()}(PartitionKey='website',RowKey='settings')?${
      API_CONFIG.sasToken
    }`;

    const response = await fetch(url, {
      headers: { Accept: "application/json;odata=nometadata" },
    });

    if (response.status === 404) {
      return emptySettings();
    }

    if (!response.ok) {
      throw new Error(`Azure Table Error: ${response.status}`);
    }

    const data = await response.json();

    return {
      about: data.About || "",
      contact: data.Contact
        ? JSON.parse(data.Contact)
        : { adresse: "", email: "", telefon: "", instagram: "" },
      impressum: data.Impressum || "",
      danke: safeParseArray(data.Danke),
      elGatoMuerto: safeParseArray(data.ElGatoMuerto),
      elGatoMuertoImages: safeParseArray(data.ElGatoMuertoImages),
      elGatoMuertoTextOben: data.ElGatoMuertoTextOben || "",
      elGatoMuertoTextUnten: data.ElGatoMuertoTextUnten || "",
    };
  } catch (error) {
    console.error("Fehler beim Laden:", error);
    throw error;
  }
};

const buildEntity = (settings) => ({
  PartitionKey: "website",
  RowKey: "settings",
  About: settings.about || "",
  Contact: JSON.stringify(settings.contact),
  Impressum: settings.impressum || "",
  Danke: JSON.stringify(settings.danke || []),
  ElGatoMuerto: JSON.stringify(settings.elGatoMuerto || []),
  ElGatoMuertoImages: JSON.stringify(settings.elGatoMuertoImages || []),
  ElGatoMuertoTextOben: settings.elGatoMuertoTextOben || "",
  ElGatoMuertoTextUnten: settings.elGatoMuertoTextUnten || "",
  UpdatedAt: new Date().toISOString(),
});

export const saveWebsiteSettings = async (settings) => {
  try {
    const entity = buildEntity(settings);

    const url = `${getBaseUrl()}?${API_CONFIG.sasToken}`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json;odata=nometadata",
      },
      body: JSON.stringify(entity),
    });

    if (response.status === 409) {
      return await updateWebsiteSettings(settings);
    }

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Speichern fehlgeschlagen: ${errorText}`);
    }

    return true;
  } catch (error) {
    console.error("Fehler beim Speichern:", error);
    throw error;
  }
};

const updateWebsiteSettings = async (settings) => {
  const entity = buildEntity(settings);

  const url = `${getBaseUrl()}(PartitionKey='website',RowKey='settings')?${
    API_CONFIG.sasToken
  }`;

  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json;odata=nometadata",
    },
    body: JSON.stringify(entity),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Update fehlgeschlagen: ${errorText}`);
  }

  return true;
};
